<template>
    <div class="form">
        <el-form style="margin:20px;width:60%;min-width:600px;" label-width="180px">
            <el-form-item class='edit-form' label="销售下单号">
                <span>{{Form.OrderCode}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="发货通知单发货情况">
                <span>{{Form.DeliveryStatusName}}</span>
            </el-form-item>
            <!-- <el-form-item class='edit-form' label="状态">
                                    <span>{{Form.OrderStatusName}}</span>
                                </el-form-item>-->
            <el-form-item class='edit-form' label="代理商">
                <span>{{Form.AgentName}} {{Form.AgentAddress}} {{Form.AgentTel}}</span>
            </el-form-item>
            <el-form-item label="销售下单时间">
                <span>{{Form.OrderTime}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="销售下单人">
                <span>{{Form.SaleEmployeeName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="要求发货时间">
                <span>{{Form.RequireSendDate}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="实际发货时间">
                <span>{{Form.StockOutTime}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="实际签收时间">
                <span v-if="Form.SignTime!=''&&Form.SignTime!=undefined">{{Form.SignTime}}</span>
                <span v-else>--</span>
            </el-form-item>
            <el-form-item class='edit-form w100' label="商品" v-show="Form.ListGoods!=''">
                <el-table :data="Form.ListGoods" border style="width: 100%;  margin-left: 25px;">
                    <el-table-column prop="ProName" label="名称">
                    </el-table-column>
                    <el-table-column prop="OrderNum" label="订单数">
                    </el-table-column>
                    <!--<el-table-column prop="NeedSendNum" label="应发数">
                                        </el-table-column>-->
                    <el-table-column prop="ProNum" label="实发">
                    </el-table-column>
                    <el-table-column prop="ReceiveNum" label="实收">
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item class='edit-form w100' label="赠品" v-show="Form.GiftGoods!=''">
                <el-table :data="Form.GiftGoods" border style="width: 100%;  margin-left: 25px;">
                    <el-table-column prop="ProName" label="名称">
                    </el-table-column>
                    <el-table-column prop="OrderNum" label="订单数">
                    </el-table-column>
                    <!--<el-table-column prop="NeedSendNum" label="应发数">
                                        </el-table-column>-->
                    <el-table-column prop="ProNum" label="实发">
                    </el-table-column>
                    <el-table-column prop="ReceiveNum" label="实收">
                    </el-table-column>
                </el-table>
            </el-form-item>
    
            <el-form-item class='edit-form' label="收货地址">
                <span>{{Form.AgentConsignee}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="收货人及联系方式">
                <span>{{Form.Consignee}}--{{Form.ConsigneeTel}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="寄送方式">
                <span>{{Form.SendModeName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="支付方式">
                <span>{{Form.PayModeName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="销售下单人备注">
                <span v-if="Form.OrderRemark!=''&&Form.OrderRemark!=undefined">{{Form.OrderRemark}}</span>
                <span v-else>--</span>
            </el-form-item>
            <!--            <el-form-item class='edit-form' label="下次发货时间">
                                    <span></span>
                                </el-form-item>-->
            <el-form-item label="快递或物流名称">
                <span v-if="Form.LogisticsName!=''&&Form.LogisticsName!=undefined">{{Form.LogisticsName}}</span>
                <span v-else>--</span>
            </el-form-item>
            <el-form-item label="快递或物流单号">
                <span v-if="Form.LogisticsCode!=''&&Form.LogisticsCode!=undefined">{{Form.LogisticsCode}}</span>
                <span v-else>--</span>
            </el-form-item>
            <el-form-item class='edit-form' label="出库单备注">
                <span v-if="Form.Remark!=''&&Form.Remark!=undefined">{{Form.Remark}}</span>
                <span v-else>--</span>
            </el-form-item>
            <div v-show="Form.ReceiveTypeName!='未反馈'">
                <el-form-item class='edit-form' label="客户反馈" style="font-weight: bold">
                </el-form-item>
                <el-form-item label="类型">
                    <span>{{Form.ReceiveTypeName}}</span>
                </el-form-item>
                <el-form-item label="签收单">
                    <div class="ImgPrev" v-for="item in SignImg">
                        <div class="post-format-content">
                            <div class="post-thumbnail">
                                <img :src="item.Url" class="attachment-thumbnail wp-post-image myProPic">
                            </div>
                            <div class="content-wrap">
                                <span class="entry-title">
                                    <span class="featured-image">
                                        <i class="el-icon-view" @click="LookPicture(item.Url)"></i>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <span v-show='SignImg.length==0'>--</span>
                </el-form-item>
                <el-form-item label="其他图片">
                    <div class="ImgPrev" v-for="item in OtherImg">
                        <div class="post-format-content">
                            <div class="post-thumbnail">
                                <img :src="item.Url" class="attachment-thumbnail wp-post-image myProPic">
                            </div>
                            <div class="content-wrap">
                                <span class="entry-title">
                                    <span class="featured-image">
                                        <i class="el-icon-view" @click="LookPicture(item.Url)"></i>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <span v-show='OtherImg.length==0'>--</span>
                </el-form-item>
                <el-form-item label="备注">
                    <span v-if="Form.CustomerRemark!=''&&Form.CustomerRemark!=undefined">{{Form.CustomerRemark}}</span>
                    <span v-else>--</span>
                </el-form-item>
            </div>
        </el-form>
        <el-dialog v-model="PictureVisible" size="tiny">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>
import NProgress from 'nprogress'
import {
    GetAgentOrderStockInfo
} from '../../api/agentApi.js'
import {
    util
} from '../../common/js/util.js';
module.exports = {
    data() {
        return {
            PictureVisible: false,
            dialogImageUrl: "",
            Form: {},
            SignImg: [],
            OtherImg: [],
        }
    }
    ,
    methods: {
        LookPicture(Url) {
            this.dialogImageUrl = Url;
            this.PictureVisible = true;
        },
    },
    created: function () {
        if (this.$route.query.Id != undefined) {
            let _session = util.getSessin();
            let para = {
                Sid: _session[0],
                Session: _session[1],
                Id: this.$route.query.Id
            };


            GetAgentOrderStockInfo(para).then(res => {
                util.doResult(this, res,
                    () => {
                        this.Form = res.data.Data;
                        if (this.Form.SignImg.length > 0) {
                            for (var i = 0; i < this.Form.SignImg.length; i++) {
                                var b = {};
                                b.Url = this.Form.SignImg[i].Url;
                                b.Name = this.Form.SignImg[i].Name;
                                this.SignImg.push(b);
                            }
                        }

                        if (this.Form.OtherImg.length > 0) {
                            for (var i = 0; i < this.Form.OtherImg.length; i++) {
                                var b = {};
                                b.Url = this.Form.OtherImg[i].Url;
                                b.Name = this.Form.OtherImg[i].Name;
                                this.OtherImg.push(b);
                            }
                        }
                    });
            })
        }
    }
}
</script>
<style scoped>
.Picture {
    max-width: 80px;
}

.ImgPrev {
    float: left;
    margin-right: 5px;
    margin-left: 20px;
    width: 80px;
    height: 80px;
    position: relative;
    margin-bottom: 6px;
}

.post-format-content {
    position: relative;
    background: white;
}

.post-thumbnail {
    max-width: 100%;
    height: auto;
    overflow: hidden;
}

.content-wrap {
    padding: 0;
    position: absolute;
    text-align: center;
    width: 100%;
    top: 0;
    bottom: 0;
    display: table-cell;
    vertical-align: middle;
    overflow: hidden;
    border-radius: 8px;
}

.entry-title {
    display: table;
    font-size: 110%;
    height: 100%;
    width: 100%;
    margin: 0;
}

.edit-link {
    z-index: 2;
}

.featured-image {
    display: table-cell;
    position: relative;
    /*       transition: opacity .25s ease-in-out, background .25s ease-in-out;
                -moz-transition: opacity .25s ease-in-out, background .25s ease-in-out;
                -webkit-transition: opacity .25s ease-in-out, background .25s ease-in-out;*/
    vertical-align: middle;
    z-index: 1;
    color: #fff;
    text-decoration: none;
    opacity: 0;
    padding: 10%;
}

.featured-image:hover {
    border-radius: 8px;
    opacity: 0.9;
    color: #fff;
    background: rgba(0, 0, 0, 0.8);
}

.post-thumbnail img {
    display: block;
}

img {
    max-width: 100%;
    height: auto;
}

.myProPic {
    width: 80px;
    height: 80px;
    border-radius: 8px;
}
</style>


// WEBPACK FOOTER //
// viewAgentOrder.vue?512c7289